import React from "react";
import classNames from "classnames";

import { Props, DateType } from "./types";
import { Days } from "./days";
import { Months } from "./months";
import { Years } from "./years";
import styles from "./styles.scss";

function Calendar({ date, initialCursor, ...props }: Props) {
  const [cursor, setCursor] = React.useState(
    new Date(
      initialCursor
        ? initialCursor
        : new Date(Date.UTC(date.year, date.month, date.day)).toISOString(),
    ),
  );
  const [currentView, setCurrentView] = React.useState("days");
  const minDate = props.minDate
    ? new Date(
        Date.UTC(props.minDate.year, props.minDate.month, props.minDate.day),
      )
    : new Date(0);
  const maxDate = props.maxDate
    ? new Date(
        Date.UTC(props.maxDate.year, props.maxDate.month, props.maxDate.day),
      )
    : new Date(99999, 1);

  const handleDateChange = (newDate: Partial<DateType>) => {
    const { year, month, day } = { ...date, ...newDate };
    const c = {
      year: cursor.getUTCFullYear(),
      month: cursor.getUTCMonth(),
      day: cursor.getUTCDate(),
    };

    const nextDate = new Date(Date.UTC(c.year, c.month, day));
    const d =
      nextDate < minDate ? minDate : nextDate > maxDate ? maxDate : nextDate;

    return props.editDate({
      ...c,
      day: d.getUTCDate(),
    });
  };

  const handleCursorChange = (newDate: Partial<DateType>) => {
    const { year, month, day } = {
      year: cursor.getUTCFullYear(),
      month: cursor.getUTCMonth(),
      day: cursor.getUTCDate(),
      ...newDate,
    };
    const nextDate = new Date(Date.UTC(year, month, day));

    setCursor(
      nextDate < minDate ? minDate : nextDate > maxDate ? maxDate : nextDate,
    );
  };

  return (
    <div
      className={classNames(styles.calendar, {
        [styles.month]: currentView === "months",
        [styles.year]: currentView === "years",
      })}
    >
      <div className={styles.years}>
        <Years
          date={date}
          cursor={cursor}
          maxDate={props.maxDate}
          minDate={props.minDate}
          editCursor={handleCursorChange}
          switchViews={setCurrentView}
          clear={props.clear}
          today={props.today}
        />
      </div>
      <div className={styles.months}>
        <Months
          date={date}
          cursor={cursor}
          maxDate={props.maxDate}
          minDate={props.minDate}
          editCursor={handleCursorChange}
          switchViews={setCurrentView}
          clear={props.clear}
          today={props.today}
        />
      </div>
      <div className={styles.days}>
        <Days
          date={date}
          cursor={cursor}
          maxDate={props.maxDate}
          minDate={props.minDate}
          editDate={handleDateChange}
          editCursor={handleCursorChange}
          switchViews={setCurrentView}
          clear={props.clear}
          today={props.today}
        />
      </div>
    </div>
  );
}

export { Calendar };
